import {useEffect, useState} from 'react'

// keep in sync with the breakpoints in style/media.less
export const toDoFiltersSize = 1320
export const mobileNarrowSize = 700

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => window.matchMedia?.(query).matches ?? false)

  useEffect(() => {
    const mediaQueryList = window.matchMedia?.(query)
    if (!mediaQueryList) {
      return
    }

    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)

    setMatches(mediaQueryList.matches)
    mediaQueryList.addEventListener('change', onChange)

    return () => mediaQueryList.removeEventListener('change', onChange)
  }, [query])

  return matches
}

export function useIsToDoFiltersNarrow() {
  return useMediaQuery(`only screen and (max-width: ${toDoFiltersSize}px)`)
}

export function useIsMobileNarrow() {
  return useMediaQuery(`only screen and (max-width: ${mobileNarrowSize}px)`)
}
